/** Soft warning when catalog cache is older than this (ms) — default 3h */
export const POS_CATALOG_STALE_MS = 3 * 60 * 60 * 1000

export const POS_IDB_NAME = 'shopora-pos-offline'
export const POS_IDB_VERSION = 1

export const LS_LAST_SYNC_ATTEMPT = 'shopora.pos.lastSyncAttempt'
